import React, { useEffect, useMemo, useState } from 'react';
import { Select, TextInput } from '@opendate-app/setlist';
import { CUSTOM_WINDOW, windowDraftError, windowOptions } from './attributionReportUtils';

function WindowPicker({
  windowDays, defaultWindowDays, maxWindowDays, onChange,
}) {
  const options = useMemo(() => windowOptions(defaultWindowDays), [defaultWindowDays]);
  const [custom, setCustom] = useState(!options.some((option) => option.value === String(windowDays)));
  const [draft, setDraft] = useState(String(windowDays));
  const draftError = custom ? windowDraftError(draft, maxWindowDays) : null;

  useEffect(() => {
    const preset = options.some((option) => option.value === String(windowDays));
    setCustom(!preset);
    if (!preset) setDraft(String(windowDays));
  }, [windowDays, options]);

  const choose = (value) => {
    if (value === CUSTOM_WINDOW) {
      setDraft(String(windowDays));
      setCustom(true);
      return;
    }
    setCustom(false);
    onChange(Number(value));
  };

  const commitDraft = () => {
    if (draftError) return;
    const days = Number(draft);
    if (days !== windowDays) onChange(days);
  };

  return (
    <div className="d-flex align-items-center" style={{ gap: 8 }}>
      <Select
        size="sm"
        width={130}
        aria-label="Credit window"
        options={options}
        value={custom ? CUSTOM_WINDOW : String(windowDays)}
        onChange={choose}
      />
      {custom && (
        <div style={{ width: 140 }}>
          <TextInput
            size="sm"
            type="number"
            min={1}
            max={maxWindowDays}
            aria-label="Custom window in days"
            trailingText="days"
            value={draft}
            error={draftError || undefined}
            onChange={(event) => setDraft(event.target.value)}
            onBlur={commitDraft}
            onKeyDown={(event) => { if (event.key === 'Enter') commitDraft(); }}
          />
        </div>
      )}
    </div>
  );
}

export default WindowPicker;
